import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {ForgotEmailComponent} from './forgot-email.component';

const routes: Routes = [
    {
        path: PAGES_AND_PATHS.forgotEmailAndUsername.pageInRouting,
        data: {data: PAGES_AND_PATHS.forgotEmailAndUsername},
        component: ForgotEmailComponent,
        canActivate: [OuterPagesGuardService],
        loadChildren: () => import('./forgot-email.module').then(m => m.ForgotEmailModule)
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ForgotEmailRoutingModule {
}
